// FILE: src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/layout/DashboardLayout';
import ECommerceAnalytics from './pages/ECommerceAnalytics';
import MarketingOverview from './pages/MarketingOverview';
import CRMCustomerList from './pages/CRMCustomerList';
import ProductsList from './pages/ProductsList';
import SaaSDashboard from './pages/SaaSDashboard';
import Orders from './pages/Orders';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Registration from './pages/Registration';

function App() {
  return (
    <Router>
      <DashboardLayout>
        <Routes>
          {/* Default route redirects to E-Commerce Analytics */}
          <Route path="/" element={<Navigate to="/ecommerce" replace />} />
          
          {/* Dashboard Routes */}
          <Route path="/ecommerce" element={<ECommerceAnalytics />} />
          <Route path="/marketing" element={<MarketingOverview />} />
          <Route path="/saas" element={<SaaSDashboard />} />
          
          {/* CRM Routes */}
          <Route path="/crm" element={<Navigate to="/crm/customers" replace />} />
          <Route path="/crm/customers" element={<CRMCustomerList />} />
          <Route path="/crm/leads" element={<CRMCustomerList />} />
          <Route path="/crm/contacts" element={<CRMCustomerList />} />
          
          {/* Products Routes */}
          <Route path="/products" element={<Navigate to="/products/list" replace />} />
          <Route path="/products/list" element={<ProductsList />} />
          <Route path="/products/categories" element={<ProductsList />} />
          <Route path="/products/inventory" element={<ProductsList />} />
          
          {/* Other Routes */}
          <Route path="/orders" element={<Orders />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/settings" element={<Settings />} />
          
          {/* Authentication Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Registration />} />
        </Routes>
      </DashboardLayout>
    </Router>
  );
}

export default App;
